// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3606":"63472b61","9166":"ea9aeac5"}[chunkId] + ".chunk.css";
};